import * as angular from "angular";

export class OrganisationInviteService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.apiRoot = "/v2/organisation/invite";
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all/" + data.id, data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    resend(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/resend/" + data.organisationinviteid,
            data
        );
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/" + data.organisationinviteid,
            data
        );
    }
}

angular
    .module("vcServices")
    .service("OrganisationInviteService", OrganisationInviteService);
